<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-[#606060] dark:tw-fill-white" viewBox="0 0 24 24"><path d="M19 2H5a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5M5 4h14a3 3 0 0 1 3 3H2a3 3 0 0 1 3-3M2 17V9h9v11H5a3 3 0 0 1-3-3m17 3h-6V9h9v8a3 3 0 0 1-3 3"/></svg>
</template>
